import { render, staticRenderFns } from "./ChartBoxesContainer.vue?vue&type=template&id=773cd9bc&scoped=true"
import script from "./ChartBoxesContainer.vue?vue&type=script&lang=js"
export * from "./ChartBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./ChartBoxesContainer.vue?vue&type=style&index=0&id=773cd9bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773cd9bc",
  null
  
)

export default component.exports